<form [formGroup]="prefaceForm()" *transloco="let t; prefix: 'registration.page.prefaceForm'">
  <htx-form-section
    [title]="t('sections.documents')"
    [icon]="'description'"
  >
    <htx-button
      icon="picture_as_pdf"
      (click)="openPdf()"
    >
      {{ t('downloadPdf') }}
    </htx-button>
    <htx-checkbox-field-with-error
      [ctrl]="prefaceForm().controls['confirmation']"
      [label]="t('controls.confirmation.label')"
      [required]="true"
      [errorMessages]="{ required: '' }"
    >
    </htx-checkbox-field-with-error>
  </htx-form-section>
</form>
